/** =========================================================
 * Module: item-add-dialog.directive.js
 * Add item dialog
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.components')
    .directive('itemAddDialog', itemAddDialog);

  itemAddDialog.$inject = ['$rootScope', '$api', '$q', 'ngDialog', 'MainPreloader'];

  function itemAddDialog($rootScope, $api, $q, ngDialog, MainPreloader) {
    var directive = {
      restrict: 'A',
      link: link,
      scope: {
        config: '=',
        inputItem: '=?item',
        template: '@?'
      }
    };

    return directive;

    function link($scope, element) {
      $scope.appConfig = $rootScope.appConfig;

      element.on('click', function () {
        if ($scope.config && $scope.config.model && $scope.config.add) {
          MainPreloader.show();

          // eslint-disable-next-line no-nested-ternary
          $scope.item = angular.copy($scope.inputItem ? $scope.inputItem : $scope.config.add.item ? $scope.config.add.item : {});

          // Setup resources
          $scope.resources = {};
          $scope.resourcesLoading = {};

          var resourcePromises = [];

          if (typeof $scope.config.resources !== 'undefined') {
            $scope.config.resources.forEach(function (resource) {
              var params = { order: { id: 'desc' } };

              if ($scope.config.resourceUpdateConditions && $scope.config.resourceUpdateConditions[resource]) {
                // Params
                if ($scope.config.resourceUpdateConditions[resource].params) {
                  params = $scope.config.resourceUpdateConditions[resource].params($scope.item);
                }

                // Selected
                if ($scope.config.resourceUpdateConditions[resource].selected) {
                  var selectedAttr = $scope.config.resourceUpdateConditions[resource].selected;

                  if (typeof selectedAttr === 'function') {
                    params.selected = selectedAttr($scope.item);
                  } else {
                    params.selected = selectedAttr;
                  }
                }

                // Resource watcher
                if ($scope.config.resourceUpdateConditions[resource].watch) {
                  var watchItem = $scope.config.resourceUpdateConditions[resource].watch;

                  $scope.$watch('item.' + watchItem, function (value) {
                    params[watchItem] = $scope.item[watchItem];

                    if (typeof value !== 'undefined') {
                      $scope.resourcesLoading[resource] = true;

                      $api.resource({
                        model: resource,
                        data: params
                      }).then(function (response) {
                        $scope.resources[resource] = response.data;
                        $scope.resourcesLoading[resource] = false;
                      });
                    } else {
                      $scope.resources[resource] = [];
                    }
                  });
                }
              }

              $scope.resourcesLoading[resource] = true;

              var resourcePromise = $api.resource({
                model: resource,
                data: params
              }).then(function (response) {
                $scope.resources[resource] = response.data;
                $scope.resourcesLoading[resource] = false;
              });

              resourcePromises.push(resourcePromise);
            });
          }

          var before = $rootScope.helpers.emptyPromise;
          var beforeSubmit = $rootScope.helpers.emptyPromise;
          var success = $rootScope.helpers.emptyPromise;
          var onClose = null;

          if (typeof $scope.config.add !== 'undefined') {
            if (typeof $scope.config.add.before === 'function') {
              before = $scope.config.add.before;
            }

            if (typeof $scope.config.add.beforeSubmit === 'function') {
              beforeSubmit = $scope.config.add.beforeSubmit;
            }

            if (typeof $scope.config.add.success === 'function') {
              success = $scope.config.add.success;
            }

            if (typeof $scope.config.add.onClose === 'function') {
              onClose = $scope.config.add.onClose;
            }
          }

          $q.all(resourcePromises).then(function () {
            before($scope.item, $scope).then(function () {
              MainPreloader.hide();

              var width = '';

              if ($scope.config.add.wide) {
                width += ' ngdialog-wide';
              } else if ($scope.config.add.superWide) {
                width += ' ngdialog-super-wide';
              }

              ngDialog.openConfirm({
                template: $scope.template ? $scope.template : $scope.config.add.template,
                className: 'ngdialog-theme-default' + width,
                scope: $scope,
                closeByDocument: false,
                closeByEscape: false
              }).then(function () {
                if (onClose) {
                  onClose($scope.item);
                }

                beforeSubmit($scope.item).then(function (preparedItem) {
                  var attrs = {
                    model: $scope.config.model,
                    data: preparedItem
                  };

                  if (typeof $scope.config.add.only !== 'undefined') {
                    attrs.only = $scope.config.add.only;
                  }

                  if (typeof $scope.config.add.except !== 'undefined') {
                    attrs.except = $scope.config.add.except;
                  }

                  $api.add(attrs).then(function (response) {
                    success(response, preparedItem, $scope).then(function () {
                      // if (typeof $scope.config.getData === 'function' && $scope.config.getDataParams) {
                      //     $scope.config.getData();
                      // }
                    });
                  }, function (error) {
                    Raven.captureException(error);
                  });
                });
              });
            }, function () {
              if (onClose) {
                onClose($scope.item);
              }

              MainPreloader.hide();
            });
          }, function (error) {
            MainPreloader.hide();

            Raven.captureException(error);
          });
        }
      });
    }
  }
})();
